/* eslint-disable max-len */
import React, { Fragment } from 'react';

const AisleBayTextMeFooter = () => (
  <>
    <div className="tooltip_footer">
      <div>
        {`By providing your mobile phone number and clicking "Text Me",
        you agree to receive in-store product location text messages from 20841 sent by or on behalf of The Home Depot via automated technology.
        Consent is not a condition of purchase. Message frequency varies based on number of requests.`}
        Text <span className="u__bold">STOP</span> to 20841 to cancel in- store product location alerts (you will be
        sent a confirmation message).
        Text <span className="u__bold">HELP</span> to 20841 for help.
      </div>
      <div className="aislebay--footer">
        {`*By checking the above box and clicking "Text Me",
        you agree to receive marketing messages from 65624 sent by or on behalf of The Home Depot Text Program via automated technology.
        Consent is not a condition of purchase. You will receive up to 10 messages/month.`}
        <span className="u__bold">STOP to 65624 </span> {`to cancel The Home Depot Text Program (you will be sent a confirmation message).
        Text `}
        <span className="u__bold">HELP to 65624 </span>for help. Msg&amp;data rates may apply.
        <a href="/c/Privacy_Security">Privacy &amp; Security Statement</a>
      </div>
    </div>
  </>
);

AisleBayTextMeFooter.propTypes = {};

export { AisleBayTextMeFooter };
